'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var Account = (function () {
    function Account() {
        this.enabled = true;
    }
    Account.createInstance = function () {
        return new this;
    };
    return Account;
}());
exports.Account = Account;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImltcGwvQWNjb3VudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxZQUFZLENBQUM7O0FBU2I7SUFVSTtRQUhPLFlBQU8sR0FBWSxJQUFJLENBQUM7SUFHaEIsQ0FBQztJQUVULHNCQUFjLEdBQXJCO1FBQ0ksTUFBTSxDQUFDLElBQUksSUFBSSxDQUFDO0lBQ3BCLENBQUM7SUFDTCxjQUFDO0FBQUQsQ0FmQSxBQWVDLElBQUE7QUFmWSwwQkFBTyIsImZpbGUiOiJpbXBsL0FjY291bnQuanMiLCJzb3VyY2VzQ29udGVudCI6WyIndXNlIHN0cmljdCc7XG5cbi8vLyA8cmVmZXJlbmNlIHBhdGg9XCIuLi9jb2xsZWN0aW9ucy50c1wiIC8+XG5cbmltcG9ydCBiYXNhcmF0ID0gcmVxdWlyZSgnLi4vY29sbGVjdGlvbnMnKTtcbmltcG9ydCBjb2xsZWN0aW9ucyA9IGJhc2FyYXQuY29sbGVjdGlvbnM7XG5pbXBvcnQgTGlzdCA9IGNvbGxlY3Rpb25zLkxpbmtlZExpc3Q7XG5pbXBvcnQge2lBY2NvdW50fSBmcm9tICcuLi9hcGkvQWNjb3VudCc7XG5cbmV4cG9ydCBjbGFzcyBBY2NvdW50IGltcGxlbWVudHMgaUFjY291bnQge1xuXG4gICAgcHVibGljIHVzZXJuYW1lOiBzdHJpbmc7XG4gICAgcHVibGljIHBhc3N3b3JkOiBzdHJpbmc7XG4gICAgcHVibGljIGV4cGlyZTogRGF0ZTtcbiAgICBwdWJsaWMgZXhwaXJlUGFzc3dvcmQ6IERhdGU7XG4gICAgcHVibGljIGxvY2tlZDogYm9vbGVhbjtcbiAgICBwdWJsaWMgZW5hYmxlZDogYm9vbGVhbiA9IHRydWU7XG4gICAgcHVibGljIGNvbnRhY3Q6IGFueTtcblxuICAgIGNvbnN0cnVjdG9yKCl7IH1cblxuICAgIHN0YXRpYyBjcmVhdGVJbnN0YW5jZSgpOiBBY2NvdW50IHtcbiAgICAgICAgcmV0dXJuIG5ldyB0aGlzO1xuICAgIH1cbn0iXSwic291cmNlUm9vdCI6Ii9zb3VyY2UvIn0=



//////////////////
// WEBPACK FOOTER
// ./node_modules/janux-authorize/dist/impl/Account.js
// module id = VWr0
// module chunks = 0